import { useNavigate } from 'react-router-dom'
import { TrendingTopics } from '@/components/TrendingTopics'
import { useTrendingTopics } from '@/hooks/useTrendingTopics'

export function TrendingSidebar() {
    const navigate = useNavigate()
    const { data: topics = [] } = useTrendingTopics()

    const handleTopicClick = (uri: string) => {
        if (uri.startsWith('/hashtag/')) {
            void navigate(uri)
        } else {
            void navigate(`/feed/${encodeURIComponent(uri)}`)
        }
    }

    if (topics.length === 0) return null

    return (
        <aside
            aria-label="Trending sidebar"
            className="hidden lg:block w-56 shrink-0 sticky top-20 self-start"
        >
            <TrendingTopics topics={topics} onTopicClick={handleTopicClick} />
        </aside>
    )
}
